import React from 'react';
import {withTranslation} from "react-i18next";
import BaseSearchComponent from "./BaseSearchComponent";
import {api} from "../../services/Api/api";
import {CityApi} from "../../services/Api/types";


interface Props {
    onChange: (value: any, zip: any) => void
    onBlur: (value: any, zip: any) => void,
    value: any,
    zip: any,
    placeholder: any,
    className?: string
}

const getCityName = (city: CityApi) =>{
    return city.city_name;
}
const getPostalCode = (city: CityApi) =>{
    return city.postal_code;
}
const CitySearchComponent = (props: Props) => {
    const fetch = async (query: any) => {
        let response = await api.getCities(query);
        return response.map((c: any) => {
            let isOnlyCity = !getPostalCode(c) || response.some((x: CityApi) => getCityName(x) == getCityName(c));
            if (isOnlyCity) {
                return {
                    description: getCityName(c),
                    postal_code: getPostalCode(c)
                }
            }
            return {
                description: getCityName(c),
                postal_code: getPostalCode(c),
                renderText: () => {
                    return (
                        <>
                            {getCityName(c)}
                            {getPostalCode(c) && (
                                <small>
                                    , {getPostalCode(c)}
                                </small>
                            )}
                        </>
                    )
                }
            }
        })
    }
    const onChange = (value: any) => {
        props.onChange(value.description, value.postal_code);
    }
    const onBlur = (value: any) => {
        if(props.onBlur) {
            props.onBlur(value.description, value.postal_code);
        }
    }


    return (
        <BaseSearchComponent className={props.className} fetch={fetch} value={{description: props.value, postal_code: props.zip}} onBlur={onBlur}
                             onChange={onChange} placeholder={props.placeholder}/>
    )
}

export default withTranslation()(CitySearchComponent)